module.exports = __webpack_public_path__ + "static/img/pic09.08358ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yunkang/pic09.png
// module id = ko4N
// module chunks = 2